var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJourneyLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 880,
    height: 251,
    viewBox: "0 0 880 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M859.543 91C867.023 91 873.086 84.9558 873.086 77.5C873.086 70.0442 867.023 64 859.543 64C852.063 64 846 70.0442 846 77.5C846 84.9558 852.063 91 859.543 91Z",
    stroke: "#686868",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M859.524 85C863.679 85 867.048 81.6421 867.048 77.5C867.048 73.3579 863.679 70 859.524 70C855.369 70 852 73.3579 852 77.5C852 81.6421 855.369 85 859.524 85Z",
    fill: "#686868"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M652.717 77.75H845",
    stroke: "#686868",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 243.947H111.026C111.026 243.947 128 244.954 128 226.834C128 208.715 128 206 128 206",
    stroke: "#686868",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232 187.053H145C145 187.053 128 186.046 128 204.166C128 222.285 128 225 128 225",
    stroke: "#686868",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 251C31.6421 251 35 247.642 35 243.5C35 239.358 31.6421 236 27.5 236C23.3579 236 20 239.358 20 243.5C20 247.642 23.3579 251 27.5 251Z",
    fill: "#F03040"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5 186.697H322.04C322.04 186.697 339.04 187.697 339.04 169.697C339.04 151.697 339.04 149 339.04 149",
    stroke: "#686868",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M440.257 130.053H356C356 130.053 339 129.053 339 147.053C339 165.053 339 167.75 339 167.75",
    stroke: "#686868",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M444 130.947H519.06C519.06 130.947 536 131.954 536 113.834C536 95.7152 536 93 536 93",
    stroke: "#686868",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M650 77.053H552.984C552.984 77.053 536 76.0464 536 94.1656C536 112.285 536 115 536 115",
    stroke: "#686868",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M234.5 194C238.642 194 242 190.642 242 186.5C242 182.358 238.642 179 234.5 179C230.358 179 227 182.358 227 186.5C227 190.642 230.358 194 234.5 194Z",
    fill: "#686868"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M442.5 138C446.642 138 450 134.642 450 130.5C450 126.358 446.642 123 442.5 123C438.358 123 435 126.358 435 130.5C435 134.642 438.358 138 442.5 138Z",
    fill: "#686868"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M649.5 84C653.642 84 657 80.6421 657 76.5C657 72.3579 653.642 69 649.5 69C645.358 69 642 72.3579 642 76.5C642 80.6421 645.358 84 649.5 84Z",
    fill: "#686868"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0001 170.6C12.4429 170.6 0.600098 182.443 0.600098 197C0.600098 211.557 12.4429 223.4 27.0001 223.4C41.5573 223.4 53.4001 211.557 53.4001 197C53.4001 182.443 41.5573 170.6 27.0001 170.6ZM25.8001 184.951C23.2645 184.844 20.7973 184.406 18.4405 183.639C20.2549 180.358 22.7473 177.454 25.8001 175.112V184.951ZM25.8001 195.8V187.348C22.9213 187.232 20.0833 186.715 17.3737 185.797C15.9925 188.912 15.1873 192.294 15.0373 195.8H25.8001ZM25.8001 198.2V206.652C22.9309 206.768 20.1013 207.283 17.4001 208.195C16.0105 205.074 15.1933 201.691 15.0397 198.2H25.8001ZM25.8001 218.896V209.049C23.2753 209.156 20.8201 209.592 18.4729 210.351C20.2945 213.642 22.7725 216.566 25.8001 218.896ZM28.2001 218.888V209.049C30.7357 209.156 33.2029 209.594 35.5597 210.362C33.7453 213.642 31.2541 216.546 28.2001 218.888ZM28.2001 198.2V206.652C31.0789 206.768 33.9169 207.285 36.6253 208.203C38.0077 205.088 38.8129 201.706 38.9629 198.2H28.2001ZM28.2001 195.8V187.348C31.0789 187.232 33.9169 186.714 36.6253 185.797C38.0065 188.912 38.8117 192.294 38.9617 195.8H28.2001ZM28.2001 175.112V184.951C30.7357 184.844 33.2029 184.405 35.5597 183.638C33.7453 180.358 31.2529 177.454 28.2001 175.112ZM29.5765 173.144C34.9141 173.716 39.7189 176.058 43.4293 179.552C41.6725 180.859 39.8017 181.945 37.8313 182.788C35.8285 179.065 33.0313 175.773 29.5765 173.144ZM10.5709 179.551C12.3277 180.859 14.1997 181.945 16.1689 182.787C18.1717 179.065 20.9689 175.773 24.4213 173.143C19.0849 173.716 14.2801 176.056 10.5709 179.551ZM15.1333 184.933C13.6477 188.319 12.7873 191.992 12.6373 195.8H3.0613C3.3373 190.264 5.4817 185.223 8.8957 181.293C10.8277 182.758 12.9205 183.981 15.1333 184.933ZM15.1597 209.056C13.6645 205.665 12.7945 201.99 12.6409 198.2H3.0613C3.3361 203.736 5.4817 208.777 8.8969 212.706C10.8361 211.236 12.9373 210.01 15.1597 209.056ZM16.2061 211.197C18.2149 214.929 20.9953 218.239 24.4153 220.855C19.0813 220.281 14.2789 217.941 10.5709 214.448C12.3397 213.133 14.2237 212.043 16.2061 211.197ZM43.4281 214.449C41.6713 213.141 39.7993 212.055 37.8301 211.213C35.8285 214.935 33.0313 218.227 29.5777 220.857C34.9141 220.285 39.7189 217.944 43.4281 214.449ZM38.8657 209.067C40.3513 205.681 41.2117 202.008 41.3617 198.2H50.9389C50.6629 203.736 48.5185 208.777 45.1045 212.707C43.1725 211.243 41.0797 210.019 38.8657 209.067ZM38.8669 184.933C40.3525 188.319 41.2129 191.994 41.3629 195.8H50.9389C50.6629 190.264 48.5185 185.223 45.1045 181.293C43.1737 182.757 41.0797 183.981 38.8669 184.933Z",
    fill: "#1F1F1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.556 136.387L256.156 138.551L251.778 115.576L250.6 114.6H244.553L243.372 115.588L238.653 141.803L236.212 143.519L236.2 137.399L234.312 136.418L224.2 143.496V137.4L222.356 136.387L209.156 144.787L208.6 145.8V166.2L209.8 167.4H260.2L261.4 166.2V137.4L259.556 136.387ZM245.556 117H249.608L253.977 139.938L248.2 143.614V137.4L246.31 136.418L241.445 139.838L245.556 117ZM211 165H259V139.586L247.645 146.813L245.8 145.8V139.71L235.707 146.807L233.817 145.828L233.805 139.702L223.688 146.783L221.8 145.8V139.586L211 146.459V165Z",
    fill: "#686868"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 215.8,
    y: 153,
    width: 2.4,
    height: 4.8,
    fill: "#686868"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 221.8,
    y: 153,
    width: 2.4,
    height: 4.8,
    fill: "#686868"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 227.8,
    y: 153,
    width: 2.4,
    height: 4.8,
    fill: "#686868"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 233.8,
    y: 153,
    width: 2.4,
    height: 4.8,
    fill: "#686868"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 239.8,
    y: 153,
    width: 2.4,
    height: 4.8,
    fill: "#686868"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 245.8,
    y: 153,
    width: 2.4,
    height: 4.8,
    fill: "#686868"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 251.8,
    y: 153,
    width: 2.4,
    height: 4.8,
    fill: "#686868"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464 104.254H458.725V109.564H464V112.261H458.725V113.525L457.275 115C456.033 115 454.775 115.059 453.458 115C452.97 114.929 452.515 114.705 452.158 114.359C450.983 113.272 449.883 112.109 448.742 110.988C448.482 110.747 448.278 110.452 448.144 110.123C448.011 109.794 447.95 109.439 447.967 109.083V108.257H425.358L424 106.816V98.9267L425.392 97.4854H442.617V88.214H428.033L426.667 86.7221V57.4329L428.058 56H459.992L461.317 57.3739V86.7811L459.95 88.1887H445.4V98.7834L444 100.242H426.75V105.484H447.967V104.81C447.951 104.445 448.014 104.082 448.151 103.744C448.288 103.407 448.495 103.103 448.758 102.854C449.875 101.759 450.975 100.638 452.092 99.483C452.521 99.0509 453.103 98.8085 453.708 98.8087C454.908 98.8087 456.108 98.8087 457.325 98.8087L458.692 100.301V101.514H464V104.254ZM458.608 85.4241V58.7899H429.383V85.4241H458.608ZM455.933 112.21V101.599H453.933L450.708 104.886V108.965L453.925 112.235L455.933 112.21Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.733 70.7416H446.675L447.833 72.7813L443.817 79.5241L441.5 78.1081L444.258 73.464H441.342L440.167 71.4074L444.183 64.6646L446.5 66.1143L443.733 70.7416Z",
    fill: "#686868"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M878.749 0H842.284L841 1.26214V52.4481L842.267 53.6859H878.651L880 52.3993V1.34357L878.749 0ZM843.592 2.63014H859.167V40.0873H843.624C843.624 38.3203 843.592 14.6083 843.592 2.63014ZM843.592 51.0476V42.7826H859.176V51.0557L843.592 51.0476ZM861.833 2.67086H877.392C877.392 4.77986 877.392 38.3447 877.392 40.0873H861.857L861.833 2.67086ZM861.833 51.0313V42.7744H877.392V51.0313H861.833Z",
    fill: "#686868"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M855.714 15.8623V9.8366L854.414 8.51746H848.312L847.069 9.77146V15.8705L848.369 17.1896H854.39L855.714 15.8623ZM849.686 14.5432V11.1802H853.049V14.5432H849.686Z",
    fill: "#686868"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M855.739 21.8961H853.098V29.3957H855.739V21.8961Z",
    fill: "#686868"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M867.902 21.8961H865.261V29.3957H867.902V21.8961Z",
    fill: "#686868"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M665 5.45791L656.538 30.397H663.799L664.943 32.2092L652.27 58.8224L651.126 59.5447H647.324L646.069 58.0975L648.397 41.8026H642.255L641 40.3566L646.03 4.87242L647.285 3.78381H663.799L665 5.45791ZM648.785 57.01H650.325L661.791 32.9314H654.769L653.569 31.2573L662.031 6.31826H648.385L643.713 39.2679H649.859L651.113 40.7151L648.785 57.01Z",
    fill: "#686868"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 59,
    fill: "white",
    transform: "translate(424 56)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyLarge);
export default __webpack_public_path__ + "static/media/journey-large.2fed3a72a4cf4c2106487918e91bfe2a.svg";
export { ForwardRef as ReactComponent };